<div class="container">
  <div class="modal-header">
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="no()"
    >
      <span aria-hidden="true">X</span>
    </button>
  </div>
  <div class="modal-body">
    <h4 class="modal-title w-100">{{ description }}</h4>
  </div>
  <div class="modal-footer">
    <div class="row w-100 no-gutters justify-content-center">
      <button type="button" mdbBtn (click)="yes()" mdbWavesEffect>
        Yes
      </button>
      <button
        type="button"
        mdbBtn
        aria-label="Close"
        (click)="no()"
        mdbWavesEffect
      >
        No
      </button>
    </div>
  </div>
</div>
